import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaMagnifyingGlass } from 'react-icons/fa6';

import AddressModal from '@/resources/components/global/address/AddressModal';
import { ProductMenu } from '@/store/ducks/ProductsMenu/type';

import { ProductDetails } from './ProductDetails';
import { ProductListGrid } from './ProductListGrid';

export function ProductsWrapper({ ProductMenu }: { ProductMenu: ProductMenu | undefined }) {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="py-5">
      <div className="d-flex flex-column">
        <h5>{ProductMenu?.name}</h5>
        <p>{ProductMenu?.description}</p>
      </div>
      <div>
        {ProductMenu?.products.length ? (
          <ProductListGrid
            products={ProductMenu?.products}
            renderProduct={(product) => <ProductDetails product={product} />}
          />
        ) : (
          <div className="d-flex align-items-center">
            <p className="text-secondary">
              Os produtos do catálogo não estão disponíveis para essa loja.
            </p>
            <Button
              variant="link"
              style={{ fontSize: '0.9rem' }}
              className="mb-3 d-flex align-items-center"
              onClick={() => setShowModal(true)}
            >
              <FaMagnifyingGlass />
              Ver lista de lojas.
            </Button>
          </div>
        )}
      </div>

      <AddressModal
        showModal={showModal}
        handleClose={() => setShowModal(false)}
        showSchedule={false}
        step="type"
        setShowModal={setShowModal}
      />
    </div>
  );
}
